import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import BaseRouter from './shares/BaseRouter';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import RootStore from './store/RootStore.js';
import { THCTheme } from './shares/Theme';
import { ThemeProvider } from '@mui/material/styles';

// Einhängen in das eigentliche Root-Element
const rootElement = document.getElementById('root')
if (rootElement === null) 
  throw new Error('Kein root-container in index.html gefunden.');

// Aufbauen des Root-Elements als Basis für unsere eigene App
const root = ReactDOM.createRoot(rootElement);

// Die Information zum Basename laden wir immer aus unseren
// Entwicklungsumgebungen heraus. Den Rückfall auf "/" fügen
// wir hier nur zur Sicherheit ein
const basename = process.env.REACT_APP_BASENAME || "/";

//
// Siehe https://reactrouter.com/start/declarative/routing 
// Hier erfolgt ein Routing auf unterschiedliche App-Inhalte
//
// Erneut geändert wie hier: https://www.telerik.com/blogs/demystifying-loaders-actions-react-router-6-part-1
root.render(
  <React.StrictMode>
    <Provider store={RootStore}>
      <ThemeProvider theme={THCTheme}>
        { /* basename muss hier zum package.json homepage passen */ }
        <BrowserRouter basename={basename}> 
          <BaseRouter />
        </BrowserRouter>
      </ThemeProvider> 
    </Provider>
  </React.StrictMode>
);